// eslint-disable-next-line import/extensions
import en from './en/translation.json'
// eslint-disable-next-line import/extensions
import enIE from './en-IE/translation.json'
// eslint-disable-next-line import/extensions
import ga from './ga/translation.json'
// eslint-disable-next-line import/extensions
import uk from './uk/translation.json'
// eslint-disable-next-line import/extensions
import es from './es/translation.json'
// eslint-disable-next-line import/extensions
import de from './de/translation.json'

export default {
  en: {
    translation: en,
  },
  'en-IE': {
    translation: enIE,
  },
  ga: {
    translation: ga,
  },
  uk: {
    translation: uk,
  },
  es: {
    translation: es,
  },
  de: {
    translation: de,
  },
}
